import Swal from 'sweetalert2';

export const successNotification = (title: string, timer: number = 4000) => {
  return Swal.fire({
    timerProgressBar: true,
    timer,
    grow: 'column',
    toast: true,
    position: 'bottom-end',
    icon: 'success',
    title,
    customClass: {
      container: 'zindex100000 slow-1000 swal-container',
    },
    showClass: {
      popup: 'animated fadeInDown faster',
    },
    hideClass: {
      popup: 'animated fadeOutUp faster',
    },
  });
};
